import { messages } from '../consts';
/**
 * validate WebPos Sales SDK response.
 * @memberof posPlatform.webPos
 * @function validateSsdkResponse
 * @returns {Promise} Promise object represents response
 */
export default function validateSsdkResponse(response) {
    const { isSuccess, errorMessage } = response || {};

    if (response && isSuccess) return;

    throw Object.assign(
        new Error(
            response && errorMessage
                ? errorMessage 
                : messages.invalidResponse
        ),
        { response },
    );
}